import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../../../../utils/Functions";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { cancelButtonVariant } from "../../../../../../components/buttons/ConfirmAndCancelButtons";
import { MUI_BUTTON_NEGATIVE } from "../../../../../../css/MuiClasses";

export function TierDetailsDialog({ tier, isOpen, onClose }) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (!tier) return null;
  return (
    <Dialog
      open={Boolean(isOpen)}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      fullScreen={isMobile}
    >
      <DialogTitle sx={{ fontWeight: "bold" }}>{t(tier.title)}</DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3 }}>
        <Typography
          variant="body1"
          sx={{ mb: 2, textAlign: "justify", whiteSpace: "pre-line" }}
        >
          {t(tier.longDescription)}
        </Typography>

        <Typography variant="h6" sx={{ mb: 1 }}>
          {t("FeaturesIncluded")}
        </Typography>
        <List>
          {tier.features.map((feature, index) => (
            <ListItem key={index} sx={{ alignItems: "center", py: 0 }}>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <CheckCircleIcon color="primary" fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={t(feature)} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          color="error"
          variant={cancelButtonVariant}
          className={MUI_BUTTON_NEGATIVE}
        >
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}